/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useEffect, useState} from "react"
import {UltrasonicPropertiesObject, UltrasonicPropertiesTableRow, UltrasonicPropsKeyToTitleMap} from "../../constants"
import {MRT_ColumnDef} from "material-react-table";

import {ArgosTableSimple} from "../../../../../components/Table/ArgosTableSimple";

interface IUltrasonicPropertiesProps {
  sensorUltrasonicData: any
  isDialogOpen: boolean
  handleTempChange: any
  baselineData: any
  temperatureArray: number[]
}


const UltrasonicProperties = (props: IUltrasonicPropertiesProps) => {
  const [rowsData, setRowsData] = useState<UltrasonicPropertiesTableRow[]>([]);

  useEffect(() => {
    mapPropsToRowFormat()
  }, [props])

  const ultrasonicPropertiesTableColumns: MRT_ColumnDef<UltrasonicPropertiesTableRow>[] = [
    {
      header: "Name",
      accessorKey: "propertyName",
      enableEditing: false,
      minSize: 250
    },
    {
      header: "Value",
      accessorKey: "propertyValue",
      enableEditing: true,
      Cell: ({cell}) => {
        return <div>{cell.getValue() as any}</div>
      }
    },
    {
      header: "Unit",
      accessorKey: "unit",
      enableEditing: false,
    },
  ]

  /**
   * Intrumentation limits are inside the plot_data subobject so break the key down and access the value
   * @param propertyObject
   * @returns
   */
  const getValueIfKeyIsComposed = (propertyObject: UltrasonicPropertiesObject) => {
    let compositeKey: string[] = []
    let _key: string = propertyObject.key;
    let compositeValue: any = ""
    if (_key.includes(".")) {
      compositeKey = compositeKey.concat(_key.split("."))
      compositeKey.forEach((keySection: string) => {
        if (compositeValue == "") {
          compositeValue = props?.sensorUltrasonicData[keySection]
        } else {
          compositeValue = compositeValue?.[keySection]
        }
      })
    }
    return compositeValue
  }


  const mapPropsToRowFormat = () => {
    let _rowsData: UltrasonicPropertiesTableRow[] = []
    UltrasonicPropsKeyToTitleMap.forEach((propertyObject: UltrasonicPropertiesObject) => {
      let _key: string = propertyObject.key;
      // get value from supbject if property is one of the instrumentation limits
      let compositeValue = getValueIfKeyIsComposed(propertyObject);
      let _propertyValue = compositeValue == "" ? props?.sensorUltrasonicData[_key] : compositeValue
      if (_key == "temperature") {
        _propertyValue = props?.baselineData?.temperature
      }
      let rowObject: UltrasonicPropertiesTableRow = {
        propertyName: propertyObject.label,
        unit: propertyObject.unit,
        propertyValue: _propertyValue
      }
      _rowsData.push(rowObject)
    })
    setRowsData(_rowsData)
  }

  return (
    <div style={{padding: "5px"}}>
      <ArgosTableSimple
        columns={ultrasonicPropertiesTableColumns}
        data={rowsData}

        initialState={{density: 'compact'}}
        enablePagination={false}
        enableBottomToolbar={false}
      />
    </div>
  )
}

export default UltrasonicProperties